import { Component, OnDestroy, OnInit } from "@angular/core";
import { ColumnMapping, DataFilter } from "../../core/components/dynamic-table/dynamic-table.component";
import { CardItemMapping } from "@core/components/dynamic-cards/dynamic-cards.component";
import { CompanyV2Service } from "@core/services/company-v2.service";
import { CompaniesSearchService } from "src/app/services/companies-search/companies-search.service";
import { TabUtilsService } from "src/app/services/tab-utils.service";
import { BehaviorSubject, Subject, Subscription, takeUntil } from "rxjs";
import { GlobalModalService } from "@core/services/global-modal.service";
import { RouterService } from "src/app/services/router/router.service";
import { Nullable } from "primeng/ts-helpers";
import { DeviceDetectorService } from "ngx-device-detector";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/auth/auth.service";
import { StatsType, TabStatsService } from "../../core/services/tab-stats.service";
import { HorizontalBarType } from "@core/components/generic-listing/generic-listing.component";
import { InvestorTab } from "@core/models/types";
import { MessageService } from "primeng/api";

@Component({
  selector: "bpc-elevation",
  templateUrl: "./elevation.component.html",
  styleUrl: "./elevation.component.scss",
})
export class ElevationComponent implements OnInit {

  companies: CardItemMapping[] | any = [];
  companiesColumns!: ColumnMapping[];
  HorizontalBarType = HorizontalBarType;

  elevationsColumns: ColumnMapping[] = [
    { header: "Company", showHeader: false, mappedTo: "nameColumn", case: "company", sortable: true, sortProperty: "name", sortDirection: "desc" },
    { header: "Outreach Owner	", showHeader: true, mappedTo: "outreachOwnerName", editable: true, editAction: "editOutReachOwner"},
    { header: "HC / 1Y / 2Y", showHeader: true, mappedTo: "hC1Y2YColumn", editable: true, editAction: "editHC"},
    { header: "PIC", showHeader: true, mappedTo: "totalPICColumn", editable: true, editAction: "editPIC"},
    //{ header: "Coverage", showHeader: true, mappedTo: "coverageUsersList", editable: true, editAction: "editCoverage"},
    { header: "Investors", showHeader: true, mappedTo: "investorsList", editable: true, editAction: "editInvestors"},
    { header: "Financials", showHeader: true, mappedTo: "targetFinancialsColumn", editable: true, editAction: "editFinancials" },
    { header: "Next Steps", showHeader: true, mappedTo: "nextStepColumn", editable: true, editAction: "editNextStep"},
  ];

  weeklyElevationsColumns: ColumnMapping[] = [
    { header: "Company", showHeader: false, mappedTo: "nameColumn", case: "company", sortable: true, sortProperty: "name", sortDirection: "desc" },
    { header: "Elevation Owner	", showHeader: true, mappedTo: "elevationOwnerName", editable: true, editAction: "editOutReachOwner"},
    { header: "HC / 1Y / 2Y", showHeader: true, mappedTo: "hC1Y2YColumn", editable: true, editAction: "editHC"},
    { header: "PIC", showHeader: true, mappedTo: "totalPICColumn", editable: true, editAction: "editPIC"},
    //{ header: "Coverage", showHeader: true, mappedTo: "coverageUsersList", editable: true, editAction: "editCoverage"},
    { header: "Investors", showHeader: true, mappedTo: "investorsList", editable: true, editAction: "editInvestors"},
    { header: "Financials", showHeader: true, mappedTo: "targetFinancialsColumn", editable: true, editAction: "editFinancials" },
    { header: "Next Steps", showHeader: true, mappedTo: "nextStepColumn", editable: true, editAction: "editNextStep"},
  ];
  
  autoElevationsColumns: ColumnMapping[] = [
    { header: "Company", showHeader: false, mappedTo: "nameColumn", case: "company"},
    { header: "Stage", showHeader: true, mappedTo: "stage", editable: true, editAction: "changeStatusV2"},
    { header: "Coverage", showHeader: true, mappedTo: "coverageUsersList", editable: true, editAction: "editCoverage"},
    { header: "Days Since Last Interaction", showHeader: true, mappedTo: "lastInteraction", editable: false},
    { header: "# Of Emails Sent", showHeader: true, mappedTo: "emailNumber", editable: false},
  ];

  childTabs: any[] =[
    {label: "Weekly Elevations", route: ""},
    {label: "All Elevations", route: "all"},
    {label: "My Elevations", route: "my"},
    {label: "Stats", route: "report", disabled: this.isMobile},
    {label: "Auto Elevations(alpha)", route: "auto", class:"grey-tab"},
  ]

  companiesFilter: DataFilter = {
    pageNumber: 1,
    pageSize: 100,
    sortDirection: "asc",
    sortProperty: "name",
    tagsInclude: [103018], 
    statusesInclude: [13],
    isMyElevation: false,
  };

  totalCount = 0;
  type : string | null = "";
  selectedElevationFilter = "";
  showWeeklyData = true;
  isLoading = false;
  filterByMyElevations = false;
  showElevationReport = false;
  statsType: StatsType = StatsType.ELEVATION;


  private refreshDataSubscription!: Subscription;
  private changeChildTabSubscription!: Subscription;

  get isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
  }

  get HorizontalBar(){
    return this.type == "all" ? HorizontalBarType.Timeline : HorizontalBarType.None;
  }

  constructor(
    private companyV2Service: CompanyV2Service,
    private companiesSearchService: CompaniesSearchService,
    private tabUtilsService: TabUtilsService,
    private routerService: RouterService,
    private deviceDetectorService: DeviceDetectorService,
    private tabStatsService: TabStatsService,
    private messageService: MessageService,
  ) {

  }

  protected showErrorToastMessage(message: string) {
    this.messageService.add({ key: "home-bc", severity: "error", detail: message, life: 10_000 });
  }
  protected showSuccessToastMessage(message: string) {
    this.messageService.add({ key: "home-bc", severity: "success", detail: message, life: 5_000 });
  }

  ngOnInit(): void {
    this.routerService.updateCurrentTab(InvestorTab.ELEVATIONS);
    const url = this.routerService.url;

    if (url) {
      this.type = url.substring(url.lastIndexOf('/') + 1) ?? "";
    }

    this.companies = [];
    this.refreshDataSubscription = this.tabUtilsService.refreshData.subscribe(() => {
      this.tabStatsService.init(this.statsType);
      this.loadData();
    });

    this.loadData();
  }

  loadData(refreshData = true) {
    this.showElevationReport = false;
    if (this.isLoading) {
      return;
    }
    this.selectedElevationFilter = this.routerService.url;
    switch (this.type) {
      case "auto":
        this.companiesColumns = this.autoElevationsColumns;
        this.fetchAIAssistedElevations(refreshData);
        this.statsType = StatsType.AUTO_ELEVATIONS;
        break;
      case "all":
        this.companiesFilter.tagsInclude = undefined;
        this.companiesColumns = this.elevationsColumns;
        this.companiesFilter.isMyElevation = false;
        this.tabStatsService.init(this.statsType);
        this.fetchCompanies(refreshData);    
        break;
      case "my":
        this.companiesFilter.tagsInclude = undefined;
        this.companiesColumns = this.weeklyElevationsColumns;
        this.companiesFilter.isMyElevation = true;
        this.tabStatsService.init(this.statsType);
        this.fetchCompanies(refreshData);
        break;
      case 'report':
        this.companiesFilter.tagsInclude = undefined;
        this.showElevationReport = true;
        break;
      default:
        this.type = "";
        this.companiesFilter.tagsInclude = [103018];
        this.companiesColumns = this.weeklyElevationsColumns;
        this.companiesFilter.isMyElevation = false;
        this.tabStatsService.init(this.statsType);
        this.fetchCompanies(refreshData);
        break;
    }
  }

  fetchCompanies(refreshData = true) {
  this.isLoading = true;

  this.companiesSearchService.getElevationsV2(this.companiesFilter)
    .pipe(takeUntil(this.routerService.destroy$))
    .subscribe({
      next: (response) => {
        if (response?.data?.data) {
          this.tabStatsService.update(response.data.totalCount);
          const newCompanies = this.companyV2Service.transformElevationsData(response.data.data);

          if (refreshData) {
            this.companies = [...newCompanies];
          } else {
            this.companies.push(...newCompanies);
          }

          this.totalCount = response.data.totalCount;
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.showErrorToastMessage("Failed to load data, please refresh!");
        this.companies = [];
        if (this.companiesFilter.pageNumber) {
          this.companiesFilter.pageNumber = this.companiesFilter.pageNumber - 1;
        }
      },
      complete: () => {}
    });
  }

  fetchAIAssistedElevations(refreshData = true) {
    this.isLoading = true;

    this.companiesSearchService.getAIAssistedElevations()
      .pipe(takeUntil(this.routerService.destroy$))
      .subscribe({
      next: (response) => {
        if (response?.data?.data) {
          const newCompanies = this.companyV2Service.transformAutoElevationsData(response.data.data);
          if (refreshData) {
            this.companies = [...newCompanies];
          } else this.companies.push(...newCompanies);

          this.totalCount = response.data.totalCount;
          this.tabStatsService.update(response.data.totalCount);
          
          this.tabStatsService.init(this.statsType, this.totalCount, "Elevations");
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        if (this.companiesFilter.pageNumber) this.companiesFilter.pageNumber = this.companiesFilter.pageNumber - 1;
      },
      complete: () => {
      },
    });
  }

  loadMoreData() {
    if (this.companiesFilter.pageNumber) {
      this.companiesFilter.pageNumber = this.companiesFilter.pageNumber + 1;
      this.loadData(false);
    }
  }

  onFilterChange(filters: any) {
    this.companies = [];
    this.companiesFilter = { ...this.companiesFilter, ...filters };
    if (filters.pageNumber) {
      this.companiesFilter.pageNumber = filters.pageNumber;
    } else {
      this.companiesFilter.pageNumber = 1;
    }
    this.loadData();
  }

  ngOnDestroy(): void {
    if (this.refreshDataSubscription) {
      this.refreshDataSubscription.unsubscribe();
    }
    this.tabStatsService.destroy();
  }
}
